import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
//import { MailingPageComponent } from './component/mailing-page/mailing-page.component';
import { HistoryMailingPageComponent } from './component/history-mailing-page/history-mailing-page.component';


/* 16.09.2026 — модуль "Сформировать рассылку" отключён: функциональность не используется в реальном
 рабочем процессе. Маршрут перенаправлен на "Отправленные КП" во избежание случайного использования
 и связанных с этим ошибок. Компонент MailingPageComponent оставлен в проекте без изменений на случай
 повторного включения в будущем.*/
const routes: Routes = [
  {
    path: '',
    redirectTo: 'history',
    pathMatch: 'full'
    //component: MailingPageComponent
  },
  {
    path: 'history',
    component: HistoryMailingPageComponent
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class MailingPageRoutingModule { }



// WEBPACK FOOTER //
// ./src/app/modules/mailing-list/mailing-page-routing.module.ts